import { IKeybindingItem_input } from '@workbench-stack/core';
import { KeybindingIO } from '../../../services/keybinding/keyboardMapper/keybindingIO';
import { ResolvedKeybindingItem } from '@vscode-alt/monaco-editor/esm/vs/platform/keybinding/common/resolvedKeybindingItem';



export function reviveToResolvedKeybindingItem(keybindingItem: IKeybindingItem_input): ResolvedKeybindingItem {
    const item = KeybindingIO.readUserKeybindingItem(keybindingItem);
    let kItem: ResolvedKeybindingItem;
    const w = item.when || undefined;
    const parts = item.parts;
    if (parts.length === 0) {
        // This might be a removal keybinding item in user settings => accept it
        kItem = new ResolvedKeybindingItem(undefined, item.command, item.commandArgs, w as any, keybindingItem.isDefault, null, false);
    } else {
        const resolvedKeybindings = this.keybindingService.resolveUserBinding(keybindingItem.key);
        for (const resolvedKeybinding of resolvedKeybindings) {
            kItem = new ResolvedKeybindingItem(resolvedKeybinding, item.command, item.commandArgs, w as any, keybindingItem.isDefault, null, false);
        }
    }
    return kItem;
}
